import { forwardRef } from 'react';
import styles from './styleConstants.module.css';

export const H1 = forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h1
    ref={ref}
    className={`${styles.h1}${className ? ` ${className}` : ''}`}
    {...props}
  />
));

H1.displayName = 'H1';
